import React from 'react';
import styled from 'styled-components';

import { mediaMin } from 'common/styledMixins';
import { breakpoint, color } from 'common/styledVars';
import { HeaderSmall, BaseTransparentP, baseFontStyle } from 'components/typography';
import { useIntl, Link, FormattedMessage } from "gatsby-plugin-intl";

const CardPlaceholder = styled.div`
  flex: 1;

  @media ${mediaMin(breakpoint.desktop)} {
    max-width: 294px;
  }
`;

const CardBox = styled.div`
  position: relative;
  padding: 50px 41px;
  background-color: #ffffff;
  border: 1px solid #ecf0ef;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  border-radius: 0 0 0 0px;
  text-align: center;
  align-items: center;

  ${HeaderSmall} {
    padding: 6px 0;
    font-weight:600;
  }

 .en .zh {
    display:none;
  }

  .en .kr {
    display:none;
  }

  .en .ja {
    display:none;
  }

  .zh .en {
    display:none;
  }

  .zh .kr {
    display:none;
  }

  .zh .ja {
    display:none;
  }

  .kr .en {
    display:none;
  }

  .kr .zh {
    display:none;
  }

  .kr .ja {
    display:none;
  }

  .ja .en {
    display:none;
  }

  .ja .zh {
    display:none;
  }

  .ja .kr {
    display:none;
  }


  ${BaseTransparentP} {
    line-height: 25px;
    min-height:124px;

    a {
      color:#9db1ad;
    }

    a:hover {
      color:#00af85;
    }
  }

  svg {
    height: 60px;
  }

  @media ${mediaMin(breakpoint.desktop)} {
    max-width: 380px;

    ${HeaderSmall} {
      margin: 32px 0 14px;
    }
  }
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;

  @media ${mediaMin(breakpoint.desktop)} {
    flex-direction: row;

    & > div:first-of-type {
      ${CardBox} {
        border-radius: 0px 0 0 0px;
      }
    }

    & > div:last-of-type {
      ${CardBox} {
        border-radius: 0 0px 0px 0px;
      }
    }
  }
`;

const Key = styled.span`
  position: absolute;
  left: 34px;
  top: 28px;

  ${baseFontStyle}
  color: ${color.green.persian};
`;

const IconBox = styled.div`
  height: 70px;
  display: flex;
  align-items: center;
  margin: 32px 0 0;
`;

interface OwnProps {
  cards: {
    title: string;
    text: string;
    Link: string;
    Lasttext: string;
    Icon: React.ElementType;
  }[];
  className?: string;
}

const IteratingCards = ({ cards, className }: OwnProps) => {
  const intl = useIntl()
  return (
  <Container className={className}>
    {cards.map(({ title, Icon, text, Link, Lasttext, titleZH, textZH, titleKO, textKO, titleJP, textJP }, index) => (
      <CardPlaceholder key={index}>
        <CardBox>
          <IconBox>
            <Icon />
          </IconBox>
            <div className={intl.formatMessage({ id: "language" })}>
              <Key>{String(index + 1).padStart(2, '0')}</Key>
              <HeaderSmall className="en">{title}</HeaderSmall>
              <BaseTransparentP className="en">{text}</BaseTransparentP>
              <HeaderSmall className="zh">{titleZH}</HeaderSmall>
              <BaseTransparentP className="zh">{textZH}</BaseTransparentP>
              <HeaderSmall className="kr">{titleKO}</HeaderSmall>
              <BaseTransparentP className="kr">{textKO}</BaseTransparentP>
              <HeaderSmall className="ja">{titleJP}</HeaderSmall>
              <BaseTransparentP className="ja">{textJP}</BaseTransparentP>
          </div>
        </CardBox>
      </CardPlaceholder>
    ))}
  </Container>
  );
};

export default styled(IteratingCards)``;
